import React from 'react';
import cx from 'classnames';
import SliderContext from './context';
import { Link } from 'react-router-dom';



import Mark from './Mark'
import './Item.scss'

const Item = ({ movie }) => (
  <SliderContext.Consumer>
    {({ onSelectSlide, currentSlide, elementRef }) => {
      const isActive = currentSlide && currentSlide.id === movie.id;

      return (
        <div
          ref={elementRef}
          className={cx('item', {
            'item--open': isActive,
          })}
        >
          {movie.name ? <Link to={"/game/" + movie.id}><img src={movie.image_url} alt={movie.title + " image"} style={{ cursor: "pointer", display: "block", textDecoration: "none" }} /></Link> : <Link to={"/movie/" + movie.id}><img src={movie.image_url} alt={movie.title + " image"} style={{ cursor: "pointer", display: "block", textDecoration: "none" }} /></Link>}

          {isActive && <Mark />}
        </div>
      );
    }}
  </SliderContext.Consumer>
);

export default Item;
